<template>
<div >
  <common ref="common" />
    <v-toolbar
          dark
          color="primary"
        >
          <v-toolbar-title>About Us</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn
            icon
            dark
            @click="closeDialog"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          </v-toolbar-items>
    </v-toolbar>
  <v-sheet >
    <div  class=" h-100 mx-6 py-5 pb-10">
      <div class="d-flex pt-5">
        <h4>VYAPARI VYAVASAYI EKOPANA SAMITHI PALAKKAD</h4>
      </div>
      <div class="pt-2"> Registered under the Societies Registration Act
      XXI, 1860 having its registered address at Kerala Vyapari Vyavasayi Ekopana
      Samithi, 41/2235, Vyapara Bhavan, Manjakulam Road, Palakkad – 678014 with an
      aim to promote and help entrepreneurs to nurture their business activities by providing
      necessary training for skill development, legal awareness, accounting and
      taxation and other activities as may be of interest for the business community.
      </div>
    </div>
  </v-sheet>
</div>
</template>
<script>
export default {
  components: {
    common: () => import("@/components/tools/common.vue"),
  },
  methods: {
    closeDialog() {
      this.$emit("closeDialog");
    },
  },
};
</script>
<style>
.overflow-80 {
  max-height: 80vh;
  overflow: auto;
}
</style>